import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AUTH_REQUIRED } from '@app/tokens';
import { AuthRequiredError } from '@services/auth-required-error';
import { AuthService } from '@services/auth.service';
import { Observable, from, switchMap, throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthInterceptor implements HttpInterceptor {
  private authService = inject(AuthService);

  intercept(req: HttpRequest<object>, next: HttpHandler): Observable<HttpEvent<object>> {
    return from(this.handleRequest(req)).pipe(
      switchMap(request => (request ? next.handle(request) : throwError(() => new AuthRequiredError()))),
    );
  }

  async handleRequest(request: HttpRequest<object>): Promise<HttpRequest<object> | null> {
    const authRequired = request.context.get(AUTH_REQUIRED);

    if (authRequired) {
      const session = await this.authService.fetchSession();
      if (!session) {
        this.authService.logout('AuthInterceptorAuthRequired');
        return null;
      }
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${session.cognitoAccessToken}`,
          'X-Api-Key': `Bearer ${session.accessToken}`,
        },
      });
    }

    return request;
  }
}
